import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d4cdb7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "navigation",
  "aria-label": "Pagination Navigation"
}
const _hoisted_2 = { class: "oxd-pagination__ul" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_pagination_page_item = _resolveComponent("oxd-pagination-page-item")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_ctx.showPrevious)
        ? (_openBlock(), _createBlock(_component_oxd_pagination_page_item, {
            key: 0,
            previous: "",
            onClick: _ctx.onClickPrevious
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageItems, (page) => {
        return (_openBlock(), _createBlock(_component_oxd_pagination_page_item, {
          key: page,
          page: page,
          selected: page === _ctx.currentPage,
          onClick: ($event: any) => (_ctx.onClickPage(page, $event))
        }, null, 8, ["page", "selected", "onClick"]))
      }), 128)),
      (_ctx.showNext)
        ? (_openBlock(), _createBlock(_component_oxd_pagination_page_item, {
            key: 1,
            next: "",
            onClick: _ctx.onClickNext
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}